/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const HOME_ROUTE = '/'
export const BROWSE_ALL_ROUTE = '/all'
export const PLAY_ROUTE = '/play'

// `/play` rewrites the URL to `/`, so a launch there lands on home too.
export const HOME_ENTRY_ROUTES: readonly string[] = [HOME_ROUTE, BROWSE_ALL_ROUTE, PLAY_ROUTE]
